import { TpDataContext, TpDataTable, TpDataTableColumn, VALTYPES } from './interfaces';

export function augmentDataContextColumn(
  dataContext: TpDataContext,
  dataTable: TpDataTable,
  column: TpDataTableColumn,
) {
  if (column.valueType == VALTYPES.CATEGORICAL || column.valueType == VALTYPES.MULTICAT) {
    const isMultiValued = column.valueType == VALTYPES.MULTICAT;
    // We determine the categories, their frequencies, and sort them
    const data = dataTable.columnData[column.id];
    const catMap: any = {};
    const categories = [];
    for (const cell of data) {
      const values = !isMultiValued ? [cell] : cell;
      for (const value of values) {
        if (catMap[value] === undefined) {
          categories.push({
            value,
            count: 0,
          });
          catMap[value] = categories.length - 1;
        }
        categories[catMap[value]].count++;
      }
    }

    categories.sort((cat1, cat2) => cat2.count - cat1.count);
    let catIndex = 0;
    const cat2Index: { [val: string]: number } = {};
    for (const category of categories) {
      cat2Index[category.value] = catIndex;
      catIndex++;
    }
    column.augmentedData.categories = categories;
    column.augmentedData.cat2Index = cat2Index;
  }
}

export function augmentDataContext(dataContext: TpDataContext) {
  // This is currently being stored on table_manifest level and needs to be removed from here
  for (const dataTable of dataContext.dataTables) {
    if (dataTable.canonicalTypeId == 'gene_interactions') {
      // NOTE: this is currently hardwired. @todo: fetch this from the entity ontology
      dataTable.relationsForEntity = 'multiomics_integration_table';
      dataTable.relationFrom = 'ensg_id1';
      dataTable.relationTo = 'ensg_id2';
    }

    if (dataTable.canonicalTypeId == 'demo_gene_interactions') {
      // NOTE: this is currently hardwired. @todo: fetch this from the entity ontology
      dataTable.relationsForEntity = 'demo_multiomics_integration_table';
      dataTable.relationFrom = 'ensg_id1';
      dataTable.relationTo = 'ensg_id2';
    }

    for (const column of dataTable.columns) {
      augmentDataContextColumn(dataContext, dataTable, column);
    }
  }
}
